export default "__VITE_ASSET__ro7EnBYn__"